import React, { useState } from 'react';
import { supabase } from '../../../utils/supabaseClient';
import { useNavigate } from 'react-router-dom';

function UpdatePassword() {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const navigate = useNavigate();

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    setSuccessMsg('');
    setErrorMsg('');

    if (password.length < 8) {
      setErrorMsg('Password must be at least 8 characters long.');
      return;
    }

    const { error } = await supabase.auth.updateUser({ password });

    if (error) {
      setErrorMsg(error.message);
    } else {
      setSuccessMsg('Password updated successfully. Redirecting...');
      setTimeout(() => {
        navigate('/create');
      }, 2000);
    }
  };

  return (
    <section className="auth-page contain contain-smaller align-middle">
      <h1>Update Password</h1>

      {errorMsg && <p className="error-message">{errorMsg}</p>}
      {successMsg && <p className="success-message">{successMsg}</p>}

      <form onSubmit={handleUpdatePassword}>
        <div className="user-password">
          <label htmlFor="password">New Password:</label>

          <div className="password-input-wrapper" style={{ position: 'relative' }}>
            <input
              type={showPassword ? 'text' : 'password'}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span
              className="toggle-view-pw"
              onClick={() => setShowPassword(!showPassword)}
            >
              <i className={`bi ${showPassword ? 'bi-eye-slash-fill' : 'bi-eye-fill'}`}></i>
            </span>
          </div>
        </div>

        <div className="text-center">
          <button type="submit" className="btn mt-0">Continue</button>
        </div>
      </form>

      <div>
        <p>
          <a href="/" className="link-text">Back to login</a>
        </p>
      </div>

      <div className="legal-links">
        <p className="text-center">
          <a href="/legal.html#terms-of-use" className="primary-text">Terms of Use</a> |{' '}
          <a href="/legal.html#privacy-policy" className="primary-text">Privacy Policy</a>
        </p>
      </div>
    </section>
  );
}

export default UpdatePassword;